<div
  *ngIf="(isActiveSubscription$ | async) === false && (similarNextSubscriptionTier$ | async) as similarTier"
  class="info-container"
>
  <glxy-alert
    [type]="'info'"
    [showAction]="(showAction && similarTier.allowSelfUpgrade) || (showAction && (salesDialogConfig$ | async))"
    [actionTitle]="
      similarTier.allowSelfUpgrade
        ? ('UPGRADE_SUBSCRIPTION.COMPARE_PLANS' | translate)
        : ('UPGRADE_SUBSCRIPTION.CONTACT_US' | translate)
    "
    (actionClick)="bannerAction(similarTier.allowSelfUpgrade)"
  >
    <span
      *ngIf="similarTier.allowSelfUpgrade"
      [innerHTML]="
        'UPGRADE_SUBSCRIPTION.SIMILAR_PLAN_OFFERED'
          | translate: { tierName: 'SUBSCRIPTION_TIERS.' + similarTier.id + '.NAME' | translate }
      "
    ></span>
    <span
      *ngIf="!similarTier.allowSelfUpgrade"
      [innerHTML]="'UPGRADE_SUBSCRIPTION.REACH_OUT_TO_EXPERT' | translate"
    ></span>
  </glxy-alert>
</div>

<mat-card appearance="outlined" class="row current-plan-card">
  <div class="col-md-3 col-xs-12 current-plan-header">
    <div class="row">
      <div class="col-md-12 col-xs-7">
        <div class="current-plan-subtitle">
          {{ 'SUBSCRIPTIONS.CURRENT_PLAN' | translate }}
        </div>
        <div
          class="current-plan-header-content"
          *ngIf="(currentTierId$ | async) !== '' && (currentTierId$ | async) !== null"
        >
          {{ 'SUBSCRIPTION_TIERS.' + (currentTierId$ | async) + '.NAME' | translate }}
        </div>
      </div>
      <div *ngIf="detailsUrl && detailsTextKey" class="col-md-12 col-xs-5 current-plan-content-link">
        <a (click)="goToDetails()">
          {{ detailsTextKey | translate }}
        </a>
      </div>
    </div>
  </div>
  <div class="col-md-9 col-xs-12 current-plan-content">
    <div class="row current-plan-content-margin">
      <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12" *ngIf="isOnFreeTrial$ | async">
        <div class="row">
          <div class="col-md-12 col-xs-7">
            <div class="current-plan-content-heading">
              <span>{{ 'SUBSCRIPTIONS.TRAIL_ENDS' | translate }}</span>
            </div>
            <div class="current-plan-content-value">
              <span>{{ freeTrialEndDate$ | async | glxyDate }}</span>
            </div>
          </div>
        </div>
      </div>
      <ng-container *ngIf="(isFreeTier$ | async) === false">
        <ng-container *ngIf="(subscriptionPrice$ | async) > -1; else loading">
          <ng-container *ngIf="subscriptionPricing$ | async as pricing; else loading">
            <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <div class="current-plan-content-heading">
                <span>{{ 'SUBSCRIPTIONS.PRICE' | translate }}</span>
              </div>
              <div class="current-plan-content-value">
                <span *ngIf="pricing?.currency && pricing?.frequency; else notAvailable">
                  {{ pricing.currency }}
                  {{ subscriptionPrice$ | async | price: '' : null : true }}
                  <span>
                    {{ 'BILLING_COMMON.FREQUENCY_PER.' + pricing.frequency | translate }}
                  </span>
                </span>
              </div>
            </div>
          </ng-container>
        </ng-container>
        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12" *ngIf="renewDate$ | async; else loading">
          <div class="current-plan-content-heading">
            <span>
              {{ 'BILLING_COMMON.NEXT_BILLING' | translate }}
            </span>
          </div>
          <div class="current-plan-content-value">
            <span *ngIf="(renewDateEpoch$ | async) !== 0; else notAvailable">
              {{ renewDate$ | async | date: 'mediumDate' }}
            </span>
          </div>
        </div>
      </ng-container>
      <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12" *ngIf="partnerSinceDate$ | async as partnerSinceDate">
        <div class="current-plan-content-heading">
          <span>
            {{ 'SUBSCRIPTIONS.PARTNER_SINCE' | translate }}
          </span>
        </div>
        <div class="current-plan-content-value">
          <span>{{ partnerSinceDate | glxyDate }}</span>
        </div>
      </div>
    </div>
  </div>
</mat-card>

<ng-template #loading>
  <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
    <div class="top-loading-bar stencil-shimmer"></div>
    <div class="bottom-loading-bar stencil-shimmer"></div>
  </div>
</ng-template>

<ng-template #notAvailable>
  <span>
    {{ 'SUBSCRIPTIONS.NOT_AVAILABLE' | translate }}
  </span>
</ng-template>
